import { CustomCriteriaService } from './pages/customform-editor/customCriteriaService';
import { Observable } from 'rxjs';
import { NbToastrService } from '@nebular/theme';
import { UserSessionService } from './UserSession/user-session.service';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import * as fs from 'file-saver';
import { WSA_E_CANCELLED } from 'constants';
import { encode } from 'punycode';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { hasUncaughtExceptionCaptureCallback } from 'process';


/**
 * Servicio que expone los métodos para exportar un reporte en formato Excel
 */
@Injectable({
  providedIn: 'root',
})
export class ExcelExporterService {

  constructor(private userSessionService: UserSessionService, private criteriaService: CustomCriteriaService) { }


  /**
   * Exporta los registros de un reporte de custom form
   * @param registros
   * @param formid Identificador del custom form
   * @returns
   */
  public async exportCustomReport(registros: any[],formid,skipDefaultHeaders=false){

    return new Promise<void>(resolve => {
      this.userSessionService.getCustomForm(formid).subscribe(async (customform) => {
        let report = JSON.parse(JSON.stringify(registros));

        let wb = new ExcelJS.Workbook();
        let wsReport = wb.addWorksheet('Registros')
        var columnas = [ {header: 'Usuario',key:'username',width:20},
        {header: 'Fecha/Hora ',key:'datetime',width:20},
      ]

      if(skipDefaultHeaders){
        columnas = [];
      }

        let fields = customform.dynamic_form.Fields;
        fields.sort((a,b) => (+a.pos > +b.pos) ? 1 : -1)

        fields.forEach(element => {
          if (element.id == 'location'){
            element.title = 'Localización'
          }
          columnas.push({header: element.title,key:element.id,width:50});
        });

        this.addDeprecatedColumns(columnas,report)

        wsReport.columns = columnas;

        let camposImagen = fields.filter(campo => campo.type == 'picture');
        let camposRango = fields.filter(campo => {
          return campo.type == 'date_range' || campo.type == 'datetime_range' || campo.type == 'time_range'
        })

        let camposCustom = fields.filter(campo => campo.type == 'customentity_list');

        report.map((registro) => {
          registro = Object.assign(registro,registro.form_data)
          if(registro.reportUser != undefined){
            registro.username = registro.reportUser.name +" " +registro.reportUser.surname
          }




          //console.log(camposImagen)
          camposImagen.forEach(element => {

            registro[element.id] = 'https://api.smartrural.es:8084/v1/image/report' + registro[element.id];

          });

          /**
           * CAMPOS CON RANGO
           */


          camposRango.forEach(element => {
            if(typeof registro[element.id] != 'undefined'){
              registro[element.id] = registro[element.id].from + "-" + registro[element.id].to
            }

          })

          /**
           * CAMPOS CUSTOM_ENTITY
           */
          camposCustom.forEach(element => {
            if(typeof registro[element.id] != 'undefined' && registro[element.id] != null && registro[element.id] != ''){

              var clave = Object.keys(registro[element.id]).find( k=> k!= 'id' && k!= 'element_id');
              if(element.multiselect == true && Array.isArray(registro[element.id])){
                try{
                clave = Object.keys(registro[element.id][0]).find( k=> k!= 'id' && k!= 'element_id');
                registro[element.id] = registro[element.id].map(r => r[clave])
                }catch(e){
                  console.log(e);
                }
              }else{
                registro[element.id] = registro[element.id][clave]
              }

            }
          })



          if (typeof registro.location != 'undefined' && registro.location != null){
            if (registro.location.geometry.type === 'Point'){
              registro.location = "https://www.google.com/maps/@"
              + registro.location.geometry.coordinates[1]
              + "," + registro.location.geometry.coordinates[0] +",15z";
            }else{
              registro.location = this.geojson2PostGis(registro.location.geometry);
            }
          }

          return registro;
        })

        console.log(wsReport.columns)
        console.log(report)
        report.forEach(element => {
          wsReport.addRow(element)
        })

        wsReport.getRow(1).font = {bold:true,size:14};

        var data = await wb.xlsx.writeBuffer();

          let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          await fs.saveAs(blob, report[0].form_name + '.xlsx');


      })

      console.log('Fin generateCustomReport')
      resolve()

    })




  }


  /**
   * @ignore
   * @param columnas
   * @param reportData
   */
  private addDeprecatedColumns(columnas: any[],reportData: any[]){
      var mergedReport = {}
      reportData.forEach( report => {
        mergedReport = Object.assign(mergedReport,report.form_data);
      })

      for (let key in mergedReport){
          if ( columnas.find( c => c.key == key) == null){
            columnas.push({header: key,key:key,width:50})
          }
      }

  }

  /**
   * Exporta los registros de reportes de tipo mantenimiento
   * @param registros
   */
  public exportMaintenanceReport(registros: any[]){

    let report = JSON.parse(JSON.stringify(registros));

     report.map((registro) => {
       registro.username = registro.maintenanceUser.name +" " +registro.maintenanceUser.surname


       if(null != registro.localizacion && registro.localizacion.type === "Point"){
         registro.localizacion = "https://www.google.com/maps/@"
           + registro.localizacion.coordinates[1]
           + "," + registro.localizacion.coordinates[0] +",15z";
       }else{
         registro.localizacion = this.geojson2PostGis(registro.localizacion);
       }

       if(registro.imagen != ''){
         registro.imagen = 'https://api.smartrural.es:8084/v1/image/report' + registro.imagen;
       }
       return registro;
     })
     let wb = new ExcelJS.Workbook();
     let wsReport = wb.addWorksheet('Mantenimientos')
     wsReport.columns = [
       {header: 'Usuario',key:'username',width:20},
       {header: 'Plaga/Mantenimiento',key:'maintenanceName',width:40},
       {header: 'Fecha/Hora ',key:'datetime',width:20},
       {header: 'Localizacion',key:'localizacion',width:30},
       {header: 'Detalles',key:'comentarios',width:30},
       {header: 'Imagen',key:'imagen',width:20},
     ];

     report.forEach(element => {
       wsReport.addRow(element)
     })

     wsReport.getRow(1).font = {bold:true,size:14};
     wb.xlsx.writeBuffer().then((data => {
       let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       fs.saveAs(blob, 'InformeMantenimientos.xlsx');
     }))
   }


   /**
    * Exporta los registros de tipo Plaga
    * @param registros
    */
  public exportDiseaseReport(registros: any[]){

   let report = JSON.parse(JSON.stringify(registros));

    report.map((registro) => {
      registro.username = registro.diseaseUser.name +" " +registro.diseaseUser.surname

      if(null != registro.localizacion && registro.localizacion.type === "Point"){
        registro.localizacion = "https://www.google.com/maps/@"
          + registro.localizacion.coordinates[1]
          + "," + registro.localizacion.coordinates[0] +",15z";
      }else{
        registro.localizacion = this.geojson2PostGis(registro.localizacion);
      }

      if(registro.imagen != ''){
        registro.imagen = 'https://api.smartrural.es:8084/v1/image/report' + registro.imagen;
      }
      return registro;
    })
    let wb = new ExcelJS.Workbook();
    let wsReport = wb.addWorksheet('Plagas y Enfermedades')
    wsReport.columns = [
      {header: 'Usuario',key:'username',width:20},
      {header: 'Plaga/Enfermedad',key:'diseaseName',width:40},
      {header: 'Fecha/Hora ',key:'datetime',width:20},
      {header: 'Temperatura',key:'temperature',width:10},
      {header: 'Humedad',key:'humidity',width:10},
      {header: 'Localizacion',key:'localizacion',width:30},
      {header: 'Detalles',key:'comentarios',width:30},
      {header: 'Imagen',key:'imagen',width:20},
    ];

    report.forEach(element => {
      wsReport.addRow(element)
    })

    wsReport.getRow(1).font = {bold:true,size:14};
    wb.xlsx.writeBuffer().then((data => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'InformePlagas.xlsx');
    }))
  }

  /**
   * @ignore
   * @param localizacion
   * @returns
   */
  geojson2PostGis(localizacion: any): any {
    if(null != localizacion && localizacion.coordinates.length > 1){
      let postgisStr = "POLYGON ((";
      localizacion.coordinates[0].forEach((element,index) => {
        if (index == 0){
            postgisStr = postgisStr + element[0] + " " + element[1];
        }else{
          postgisStr = postgisStr + "," + element[0] + " " + element[1];
        }
      });

      postgisStr = postgisStr + "))";

      return postgisStr;
    }

  }

  /**
   * Exporta un customform como una plantilla excel
   * @param customForm
   */
  public async exportCustomForm(customForm: any){
    console.log("Vamos a generar un excel de customform")

    let wb = new ExcelJS.Workbook();
    let ws = wb.addWorksheet(customForm.form_name);
    let cols = []

    let fieldList =  await this.userSessionService.getPromiseFieldList()
    let productList = await this.promisify(this.userSessionService.getCachedProductList())
    let machineryList = await this.promisify(this.userSessionService.getCachedMachineryList())
    let usersList = await this.promisify(this.userSessionService.getCachedUsersList())
    let customentities = await this.promisify(this.userSessionService.getCachedCustomEntitiesFullList(-1))

    customForm.dynamic_form.Fields.forEach(f => {

        if(f.type == 'date_range' || f.type == 'datetime_range'){
          cols.push({header:f.title+'(desde)',key:f.id+'_from',width:f.title.length+5})
          cols.push({header:f.title+'(hasta)',key:f.id+'_to',width:f.title.length+5})
        }else if (f.type != 'picture' && f.type != 'location'){
          cols.push({header:f.title,key:f.id,width:f.title.length+5})
        }



    })
    ws.columns = cols;

    customForm.dynamic_form.Fields.forEach( f => {
      if ( f.type == 'select' || f.type == 'multi_select' || f.type == 'radio') {

        let wslist = wb.addWorksheet(f.id)
        wslist.state = 'hidden'
        let lastRow = 0
        for (let n in f.elements){
            wslist.getRow(Number(n)+1).getCell(1).value = f.elements[n]
            lastRow = Number(n)+1
        }

       let formula = `${f.id}!$A$1:$A$${lastRow}`
       wslist.protect(formula)
        for(let i = 1;i < 1000;i++){
          ws.getRow(i).getCell(f.id).dataValidation = {
            type: 'list',
            allowBlank : true,
            showErrorMessage: true,
            formulae :[formula],

          }
        }
      }else if ( f.type == 'checkbox'){
        for(let i = 1;i < 1000;i++){
          ws.getRow(i).getCell(f.id).dataValidation = {
            type: 'list',
            allowBlank : true,
            formulae :['"Si,No"']
          }
        }
      }else if ( f.type =='date'){
        for(let i = 1;i < 1000;i++){
          ws.getRow(i).getCell(f.id).numFmt = 'dd/mm/yyyy'
        }
      }else if ( f.type == 'date_range'){
        for(let i = 1;i < 1000;i++){
          ws.getRow(i).getCell(f.id+'_from').numFmt = 'dd/mm/yyyy'
          ws.getRow(i).getCell(f.id+'_to').numFmt = 'dd/mm/yyyy'
        }
      }else if ( f.type == 'datetime'){
        for(let i = 1;i < 1000;i++){
          ws.getRow(i).getCell(f.id).numFmt = 'dd/mm/yyyy\\ hh:mm:ss'
        }
      }else if ( f.type == 'datetime_range'){
        for(let i = 1;i < 1000;i++){
          ws.getRow(i).getCell(f.id+'_from').numFmt = 'dd/mm/yyyy\\ hh:mm:ss'
          ws.getRow(i).getCell(f.id+'_to').numFmt = 'dd/mm/yyyy\\ hh:mm:ss'
        }
      }else if ( f.type == 'hour'){
        for(let i = 1;i < 1000;i++){
          ws.getRow(i).getCell(f.id).numFmt = 'hh:mm:ss'
        }
      }else if ( f.type == 'hours'){
        for(let i = 1;i < 1000;i++){
          ws.getRow(i).getCell(f.id).numFmt = '@'
        }
      }else if (f.type == 'field_list'){

        let wslist = wb.addWorksheet(f.id)
        wslist.state = 'hidden'
        let lastRow = 0
        let elements = (fieldList as Array<any>).map(f => f.name)
        for (let n in elements){
            wslist.getRow(Number(n)+1).getCell(1).value = elements[n]
            lastRow = Number(n)+1
        }
       let formula = `${f.id}!$A$1:$A$${lastRow}`
       wslist.protect(formula)

        for(let i = 1;i < 1000;i++){
          ws.getRow(i).getCell(f.id).dataValidation = {
            type: 'list',
            allowBlank : true,
            showErrorMessage: true,
            formulae :[formula]
          }
        }
      }else if (f.type == 'region_list'){

        let wslist = wb.addWorksheet(f.id)
        wslist.state = 'hidden'
        let lastRow = 0
        let elements = (fieldList as Array<any>).reduce((acc,f) => {
            if(!acc.includes(f.region)){
              acc.push(f.region)
            }
            return acc;
        },[])
        for (let n in elements){
            wslist.getRow(Number(n)+1).getCell(1).value = elements[n]
            lastRow = Number(n)+1
        }
       let formula = `${f.id}!$A$1:$A$${lastRow}`
       wslist.protect(formula)

        for(let i = 1;i < 1000;i++){
          ws.getRow(i).getCell(f.id).dataValidation = {
            type: 'list',
            allowBlank : true,
            showErrorMessage: true,
            formulae :[formula]
          }
        }
      }else if (f.type == 'product_list'){


        let wslist = wb.addWorksheet(f.id)
        wslist.state = 'hidden'
        let lastRow = 0
        let elements = (productList as Array<any>).map(f => f.name)
        for (let n in elements){
            wslist.getRow(Number(n)+1).getCell(1).value = elements[n]
            lastRow = Number(n)+1
        }
       let formula = `${f.id}!$A$1:$A$${lastRow}`
       wslist.protect(formula)
        for(let i = 1;i < 1000;i++){
          ws.getRow(i).getCell(f.id).dataValidation = {
            type: 'list',
            allowBlank : true,
            showErrorMessage: true,
            formulae :[formula]
          }
        }
      }else if (f.type == 'machinery_list'){


        let wslist = wb.addWorksheet(f.id)
        wslist.state = 'hidden'
        let lastRow = 0
        let elements = (machineryList as Array<any>).map(f => f.name)
        for (let n in elements){
            wslist.getRow(Number(n)+1).getCell(1).value = elements[n]
            lastRow = Number(n)+1
        }
       let formula = `${f.id}!$A$1:$A$${lastRow}`
       wslist.protect(formula)
        for(let i = 1;i < 1000;i++){
          ws.getRow(i).getCell(f.id).dataValidation = {
            type: 'list',
            allowBlank : true,
            showErrorMessage: true,
            formulae :[formula]
          }
        }

      }else if (f.type == 'user_list'){

        let wslist = wb.addWorksheet(f.id)
        wslist.state = 'hidden'
        let lastRow = 0
        let elements = (usersList as Array<any>).map(f => f.name+' '+f.surname)
        for (let n in elements){
            wslist.getRow(Number(n)+1).getCell(1).value = elements[n]
            lastRow = Number(n)+1
        }
       let formula = `${f.id}!$A$1:$A$${lastRow}`
       wslist.protect(formula)
        for(let i = 1;i < 1000;i++){
          ws.getRow(i).getCell(f.id).dataValidation = {
            type: 'list',
            allowBlank : true,
            showErrorMessage: true,
            formulae :[formula]
          }
        }
      }else if(f.type == 'customentity_list'){
          var key = f.customEntityConfig.key;
          var entity = (customentities as [any]).find(e => e.id == f.customEntityConfig.entity);
          if(entity != undefined && entity != null && entity.elements != undefined && entity.elements != null){
            var listaElementos = entity.elements.map(e => {

              return e.attributes.find(a => a.id == key).value;

            });
            listaElementos = [...new Set(listaElementos)]
            let wslist = wb.addWorksheet(f.id)
            wslist.state = 'hidden'
            let lastRow = 0
            for (let n in listaElementos){
              wslist.getRow(Number(n)+1).getCell(1).value = listaElementos[n]
              lastRow = Number(n)+1
            }
            let formula = `${f.id}!$A$1:$A$${lastRow}`
            wslist.protect(formula)
            for(let i = 1;i < 1000;i++){
            ws.getRow(i).getCell(f.id).dataValidation = {
              type: 'list',
              allowBlank : true,
              showErrorMessage: true,
              formulae :[formula]
            }
          }
          }

      }
    })

    let wsmetadata = wb.addWorksheet('metadata')
    wsmetadata.state = 'hidden'
    wsmetadata.getRow(1).getCell(1).value = customForm.updatedAt
    wsmetadata.protect('metadata!$A$1:$A$1')

    wb.xlsx.writeBuffer().then((data => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'reporte.xlsx');
    }))

  }

  /**
   * @ignore
   * @param entities
   */
  public exportEntities(entities: any){
    console.log("Vamos a generar un excel")

    let wb = new ExcelJS.Workbook();
    let wsMachinery = wb.addWorksheet('Maquinaria');
    wsMachinery.columns = [
      {header: 'Id',key:'id',width:10},
      {header: 'Nombre',key:'name',width:50},
      {header: 'Desactivo en',key:'disabledAt',width:20}
    ];
    entities.machinerylist.forEach(element => {
      console.log("Añadiendo fila ");
      console.log(element);

      wsMachinery.addRow(element);
    });

    let wsDisease = wb.addWorksheet('Plagas y Enfermedades');
    wsDisease.columns = [
      {header: 'Id',key:'id',width:10},
      {header: 'Nombre',key:'name',width:50},
      {header: 'Desactivo en',key:'disabledAt',width:20}
    ];
    entities.diseaselist.forEach(element => {
      console.log("Añadiendo fila ");
      console.log(element);

      wsDisease.addRow(element);
    });

    let wsMaintenance = wb.addWorksheet('Mantenimientos');
    wsMaintenance.columns = [
      {header: 'Id',key:'id',width:10},
      {header: 'Nombre',key:'name',width:50},
      {header: 'Desactivo en',key:'disabledAt',width:20}
    ];
    entities.maintenancelist.forEach(element => {
      console.log("Añadiendo fila ");
      console.log(element);

      wsMaintenance.addRow(element);
    });

    let wsProducts = wb.addWorksheet('Productos');
    wsProducts.columns = [
      {header: 'Id',key:'id',width:10},
      {header: 'Nombre',key:'name',width:50},
      {header: 'Cantidad',key:'cantidad',width:10},
      {header: 'Precio',key:'precio',width:10},
      {header: 'Desactivo en',key:'disabledAt',width:20}
    ];
    entities.productlist.forEach(element => {
      console.log("Añadiendo fila ");
      console.log(element);

      wsProducts.addRow(element);
    });

    wb.xlsx.writeBuffer().then((data => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'Entidades.xlsx');
    }))
  }

  /**
   * Importar custom report
   * @param filename Nombre del archivo
   * @param customForm
   * @returns
   */
  public async readCustomReport(filename: any, customForm:any):Promise<any>{
    let wb = (await this.readCustomReportWB(filename))
    let ws = wb.getWorksheet(1)
    let wsmetadata = wb.getWorksheet('metadata');

    if (wsmetadata == null || wsmetadata.getRow(1).getCell(1).value != customForm.updatedAt){
      throw('outdatedTemplate')
    }

    var listas = getListasExcel(wb,wsmetadata.id)


    let json = this.wsToJson(customForm, ws);
    console.log(json)
    let validatedJson = this.validarCustomForm(customForm, json,listas);

    return validatedJson;



  }

/**
 *
 * @param customForm
 * @param json
 */
  public validarSingleCustomForm(customForm:any, j:any,listas:any={},customentities: any,prefixTitle:string='') {

    j.errorMessage = [];

    customForm.dynamic_form.Fields.forEach(f => {




      if (f.required == true || f.required == 'true') {
        if (j[f.id] == '' || j[f.id] == null || j[f.id] == 'null' || (f.type == 'number' && j[f.id] == 'NaN')) {
          j.errorMessage.push(`El campo ${prefixTitle}${f.title} no puede estar vacío`);

        }
      }
      let sdf = 'YYYY/MM/DD';
      if (f.type == 'date' || f.type == 'date_range') {
        sdf = 'YYYY/MM/DD';
      } else if (f.type == 'datetime' || f.type == 'datetime_range') {
        sdf = 'YYYY/MM/DD HH:mm:ss';
      }
      if (f.type == 'date' || f.type == 'datetime') {

        if(j[f.id] != undefined && j[f.id] != null &&  j[f.id] != '' &&  (moment(j[f.id]).format(sdf) == 'Invalid date' || moment(j[f.id]).year() < 1000)){
          j.errorMessage.push(`El campo ${prefixTitle}${f.title} no se ajusta al formato de fecha/hora`)
        }else if(f.criteria != undefined && f.criteria != null && f.criteria != '' && !this.criteriaService.validateValue(f.criteria,j[f.id],f.type)){
          j.errorMessage.push(`El campo ${prefixTitle}${f.title} no cumple el criterio: ${this.criteriaService.validaExpresion(f.criteria,f.type)}`)
        }

      }

      if (f.min != null && f.min != '') {
        let fmin: Date = moment().toDate();
        if (f.min != 'current') {
          fmin = moment(f.min, sdf).toDate();
        }
        if (f.type == 'date_range' || f.type == 'datetime_range') {
          if(j[f.id].from != undefined && j[f.id].from != null &&  j[f.id].from != '' &&  moment(j[f.id].from).format(sdf) == 'Invalid date'){
            j.errorMessage.push(`El campo ${prefixTitle}${f.title} no se ajusta al formato de fecha/hora`)
          } else if(f.criteria != undefined && f.criteria != null && f.criteria != '' && !this.criteriaService.validateValue(f.criteria,j[f.id].from,f.type)){
            j.errorMessage.push(`El campo ${prefixTitle}${f.title} no cumple el criterio: ${this.criteriaService.validaExpresion(f.criteria,f.type)}`)
          }
          if(j[f.id].to != undefined && j[f.id].to != null &&  j[f.id].to != '' &&  moment(j[f.id].to).format(sdf) == 'Invalid date'){
            j.errorMessage.push(`El campo ${prefixTitle}${f.title} no se ajusta al formato de fecha/hora`)
          }
          if (j[f.id].from != null && j[f.id].from < fmin) {

            j.errorMessage.push(`El campo ${prefixTitle}${f.title} no puede contener valores anteriores a ${fmin}`)
          }


        } else if (f.type == 'date' || f.type == 'datetime') {

          if(j[f.id] != undefined && j[f.id] != null &&  j[f.id] != '' &&  moment(j[f.id]).format(sdf) == 'Invalid date'){
            j.errorMessage.push(`El campo ${prefixTitle}${f.title} no se ajusta al formato de fecha/hora`)
          } else if(f.criteria != undefined && f.criteria != null && f.criteria != '' && !this.criteriaService.validateValue(f.criteria,j[f.id],f.type)){
            j.errorMessage.push(`El campo ${prefixTitle}${f.title} no cumple el criterio: ${this.criteriaService.validaExpresion(f.criteria,f.type)}`)
          }
          if (j[f.id] != undefined && j[f.id] != null &&  j[f.id] != '' &&  j[f.id] < fmin) {
            j.errorMessage.push(`El campo ${prefixTitle}${f.title} no puede contener valores anteriores a ${fmin}`)
          }


        }

      }

      if (f.max != null && f.max != '') {
        let fmax: Date = moment().toDate();
        if (f.max != 'current') {
          fmax = moment(f.max, sdf).toDate();
        }
        if (f.type == 'date_range' || f.type == 'datetime_range') {
          if (j[f.id].to != null && j[f.id].to > fmax) {
            j.errorMessage.push(`El campo ${prefixTitle}${f.title} no puede contener valores posteriores a ${fmax}`)
          }

        } else if (f.type == 'date' || f.type == 'datetime') {
          if (j[f.id] > fmax) {
            j.errorMessage.push(`El campo ${prefixTitle}${f.title} no puede contener valores posteriores a ${fmax}`)
          }
        }


      }

      if (f.type == 'date_range' || f.type == 'datetime_range') {
        if (j[f.id].from != null && j[f.id].to != null && j[f.id].from > j[f.id].to) {
          j.errorMessage.push(`El campo ${prefixTitle}${f.title} no puede contener valores de inicio(desde) posteriores al valor final(hasta)`)
        }

      }

      if (f.type == 'number' && j[f.id] != undefined && j[f.id] != null && j[f.id] != 'null' && j[f.id] != 'NaN'){
        if(isNaN(+j[f.id]) || !(typeof j[f.id] == 'number' || typeof j[f.id] == 'string')){
          j.errorMessage.push(`El campo ${prefixTitle}${f.title} debe ser numérico`)
        }else  if(f.criteria != undefined && f.criteria != null && f.criteria != '' && !this.criteriaService.validateValue(f.criteria,j[f.id],f.type)){
          j.errorMessage.push(`El campo ${prefixTitle}${f.title} no cumple el criterio: ${this.criteriaService.validaExpresion(f.criteria,f.type)}`)
        }
      }

      if(f.type == 'hours'){
        let regex = /^\d?\d:[0-5]\d$/;
        if(j[f.id] != undefined && j[f.id] != null &&  j[f.id] != '' &&  regex.exec(j[f.id]) == null){
          j.errorMessage.push(`El campo ${prefixTitle}${f.title} debe ajustarse al formato 00:00`)
        } else if(f.criteria != undefined && f.criteria != null && f.criteria != '' && !this.criteriaService.validateValue(f.criteria,j[f.id],f.type)){
          j.errorMessage.push(`El campo ${prefixTitle}${f.title} no cumple el criterio: ${this.criteriaService.validaExpresion(f.criteria,f.type)}`)
        }
      }

      //Comprobamos valores en lista
      if(listas != undefined && listas != null &&  listas[f.id] != undefined && listas[f.id] != null && j[f.id] != undefined && j[f.id] != null && j[f.id] != '' && !listas[f.id].includes(j[f.id])){
        j.errorMessage.push(`El valor no pertenece a la lista de opciones del campo ${prefixTitle}${f.title}`)

      }
      //Fijamos los valores definitivos
      if (f.type == 'date_range' || f.type == 'datetime_range') {
        j[f.id]

          if (j[f.id].from != null && j[f.id].from != '' &&  moment(j[f.id].from).format(sdf) != 'Invalid date') {
            j[f.id].from = moment(j[f.id].from).format(sdf);
          }
          if (j[f.id].to != null && j[f.id].to != '' &&  moment(j[f.id].to).format(sdf) != 'Invalid date') {
            j[f.id].to = moment(j[f.id].to).format(sdf);
          }

      }


      if (f.type == 'date' || f.type == 'datetime') {


          if (j[f.id] != null && j[f.id] != '' && moment(j[f.id]).format(sdf) != 'Invalid date') {
            j[f.id] = moment(j[f.id]).format(sdf);
          }


      }

      if (f.type == 'checkbox' ) {

          j[f.id] = j[f.id] == 'Si';


      }


      //Fijamos los valores de las customentity

      if(f.type == 'customentity_list' && null != customentities){

        var key = f.customEntityConfig.key;
        var entity = (customentities as [any]).find(e => e.id == f.customEntityConfig.entity);

          if(typeof j[f.id] == 'string'){
            //Buscar el valor correspondiente en la lista de elementos
            var elemento = entity.elements.find(e => e.attributes.find(a => a.id == key).value == j[f.id]);
            var elementoVal= {id:entity.id};
            elementoVal[key] = j[f.id];
            if(key == 'name'){
              elementoVal['element_id'] = elemento.id;
            }
            j[f.id] = elementoVal;

          }else if(Array.isArray(j[f.id])){
            j[f.id]=j[f.id].map(v => {
              if(typeof v == 'string'){
                //Buscar el valor correspondiente en la lista de eleemntos
                var elemento = entity.elements.find(e => e.attributes.find(a => a.id == key).value == v);
                var elementoVal= {id:entity.id};
                elementoVal[key] = v;
                if(key == 'name'){
                  elementoVal['element_id'] = elemento.id;
                }
                return elementoVal;
              }else{
                return v;
              }
            })
          }
      }

    });


  }

  /**
   * @ignore
   * @param customForm
   * @param json
   * @returns
   */
  public async validarCustomForm(customForm: any, json: any[],listas:any = {}): Promise<any> {
    let errores = []
    let customentities = await this.promisify(this.userSessionService.getCachedCustomEntitiesFullList(-1))
    json.forEach(j => {
      this.validarSingleCustomForm(customForm,j,listas,customentities);
    })

    let retorno = {
      valid:  json.filter( j => j.errorMessage.length == 0).map(r => {
        var re = Object.assign({},r)
        delete re.errorMessage
        return re;
      }),
      notValid: json.filter( j => j.errorMessage.length > 0)
    }

    return retorno;

    /*


    customForm.dynamic_form.Fields.forEach(f => {


      let valores = json.map(j => j[f.id]);
      if (f.required == true || f.required == 'true') {
        if (valores.filter(v => v == '' || v == null).length > 0) {
          errores.push(`El campo ${f.title} no puede estar vacío`);

        }
      }
      let sdf = 'YYYY/MM/DD';
      if (f.type == 'date' || f.type == 'date_range') {
        sdf = 'YYYY/MM/DD';
      } else if (f.type == 'datetime' || f.type == 'datetime_range') {
        sdf = 'YYYY/MM/DD HH:mm:ss';
      }
      if (f.min != null && f.min != '') {
        let fmin: Date = moment().toDate();
        if (f.min != 'current') {
          fmin = moment(f.min, sdf).toDate();
        }
        if (f.type == 'date_range' || f.type == 'datetime_range') {
          if (valores.filter(v => v.from != null && v.from < fmin).length > 0) {
            errores.push(`El campo ${f.title} no puede contener valores anteriores a ${fmin}`);
          }
        } else if (f.type == 'date' || f.type == 'datetime') {
          if (valores.filter(v => v < fmin).length > 0) {
            errores.push(`El campo ${f.title} no puede contener valores anteriores a ${fmin}`);
          }
        }

      }

      if (f.max != null && f.max != '') {
        let fmax: Date = moment().toDate();
        if (f.max != 'current') {
          fmax = moment(f.max, sdf).toDate();
        }
        if (f.type == 'date_range' || f.type == 'datetime_range') {
          if (valores.filter(v => v.to != null && v.to > fmax).length > 0) {
            errores.push(`El campo ${f.title} no puede contener valores posteriores a ${fmax}`);
          }
        } else if (f.type == 'date' || f.type == 'datetime') {
          if (valores.filter(v => v > fmax).length > 0) {
            errores.push(`El campo ${f.title} no puede contener valores posteriores a ${fmax}`);
          }
        }

      }

      if (f.type == 'date_range' || f.type == 'datetime_range') {
        if (valores.filter(v => v.from != null && v.to != null && v.from > v.to).length > 0) {
          errores.push(`El campo ${f.title} no puede contener valores de inicio(desde) posteriores al valor final(hasta)`);
        }

      }

      //Fijamos los valores definitivos
      if (f.type == 'date_range' || f.type == 'datetime_range') {
        valores.forEach(v => {
          if (v.from != null && v.from != '') {
            v.from = moment(v.from).format(sdf);
          }
          if (v.to != null && v.to != '') {
            v.to = moment(v.to).format(sdf);
          }

        });
      }


      if (f.type == 'date' || f.type == 'datetime') {
        json.forEach(j => {
          if (j[f.id] != null && j[f.id] != '') {
            j[f.id] = moment(j[f.id]).format(sdf);
          }

        });
        console.log(valores);
      }

      if (f.type == 'checkbox') {
        json.forEach(j => {
          j[f.id] = j[f.id] == 'Si';
        });
        console.log(valores);
      }


    });

    console.log(errores);
    return errores;

    */
  }

  /**
   * @ignore
   * @param customForm
   * @param ws
   * @returns
   */
  private wsToJson(customForm: any, ws: any) {
    let json = [];
    let keys = [];

    customForm.dynamic_form.Fields.forEach(f => {
      if(f.type == 'date_range' || f.type =='datetime_range'){
        keys.push(f.id+'_from')
        keys.push(f.id+'_to')
      }else if (f.type != 'picture' && f.type != 'location'){
        keys.push(f.id)
      }
    })
    ws.eachRow((r, rn) => {
      if (rn > 1) {
        let j = {};
        for (let k in keys) {
          j[keys[k]] = r.getCell(Number(k) + 1).value;
        }
        json.push(j);
      }
    });

    json = json.map( v => {
      let ks = Object.keys(v)
     ks.filter(vf => vf.endsWith('_from')).forEach( k => {
       let mk = k.replace('_from','');
       v[mk] ={'from':v[mk+'_from'],'to':v[mk+'_to']}
       delete v[mk+'_from'];
       delete v[mk+'_to'];
     })
      return v;
    })
    return json;
  }

  /**
   * @ignore
   * @param filename
   * @returns
   */
  public async readCustomReportWB(filename: any): Promise<ExcelJS.Workbook> {
    return new Promise((resolve,reject) => {
      let fr = new FileReader();
        fr.onload = function(event){
          let wb = new ExcelJS.Workbook();
        console.log("Leemos archivo");

          wb.xlsx.load(fr.result as Buffer).then(() => {
            resolve(wb);

          })
        }

        fr.readAsArrayBuffer(filename);
    })
  }

  /**
   * @ignore
   * @param filename
   * @returns
   */
  public readExcelEntities(filename: any): Promise<any> {

    return new Promise((resolve,reject) => {
      let fr = new FileReader();
      let service = this;
      fr.onload= function(event){
        let wb = new ExcelJS.Workbook();
        console.log("Leemos archivo");

      wb.xlsx.load(fr.result as Buffer).then(() => {
        console.log("leemos hoja de trabajo");
        let retorno = service.generateWorkBookJson(wb);
        console.log(retorno);
        resolve(retorno);

      })
      }

      fr.readAsArrayBuffer(filename);
    });


  }

  /**
   * @ignore
   * @param wb
   * @returns
   */
  private generateWorkBookJson(wb: ExcelJS.Workbook): any{
    let r = {};
    r['machinerylist'] = this.generateCommonEntityJson(wb.getWorksheet(1));
    r['diseaselist'] = this.generateCommonEntityJson(wb.getWorksheet(2));
    r['maintenancelist'] = this.generateCommonEntityJson(wb.getWorksheet(3));
    r['productlist'] = this.generateProductEntityJson(wb.getWorksheet(4));

    return r;
  }

  /**
   * @ignore
   * @param ws
   * @returns
   */
  private generateCommonEntityJson(ws: ExcelJS.Worksheet): any{
    let r = [];
    ws.eachRow((row,rownumber) => {
      if(rownumber > 1){
      let f = {id: '', name: ''};
        f.id = row.getCell(1).text;
        f.name = row.getCell(2).text;
        if(row.getCell(3).text != ''){
          f['disabledAt'] = row.getCell(3).text;
        }

        r.push(f);
      }
    });

    return r;
  }

  /**
   * @ignore
   * @param ws
   * @returns
   */
  private generateProductEntityJson(ws: ExcelJS.Worksheet): any{
    let r = [];
    ws.eachRow((row,rownumber) => {
      if(rownumber > 1){
      let f = {id: '', name: ''};
        f.id = row.getCell(1).text;
        f.name = row.getCell(2).text;
        f['cantidad'] = row.getCell(3).text;
        f['precio'] = row.getCell(4).text;
        if(row.getCell(5).text != ''){
          f['disabledAt'] = row.getCell(5).text;
        }

        r.push(f);
      }
    });

    return r;
  }


  /**
   * Genera los campos de custom form
   * @param form_data Datos del reporte
   * @param customform Customform
   * @returns
   */
  generateCustomFields(form_data: any,customform: any){

    let customfields = [];
    for (let [key, value] of Object.entries(form_data)) {


        let customfield = this.getFieldData(key,customform);
        if( customfield.type == 'picture'){
          customfield.value = 'https://api.smartrural.es:8084/v1/image/report' + value;
        }else{
          customfield.value = value;
        }

        customfield.key = key;
        customfields.push(customfield);

    }
    customfields.sort((a,b) => (a.pos > b.pos) ? 1 : -1)

    console.log(customfields)

    return customfields;
  }

  /**
   * Obtiene los datos de un campo
   * @param fieldid Identificador de campo
   * @param customform Id de customform
   * @returns
   */
  getFieldData(fieldid,customform): any{

    //console.log(this.customform)
    //console.log(fieldid)

    let field = customform.dynamic_form.Fields.find( e => e.id === fieldid)

    //console.log(field);
    if(field != undefined){
      return {title:field.title,type:field.type,pos:field.pos};
    }else{
      return {title:fieldid,type:'text',pos:100};
    }

  }

  /**
   * @ignore
   * @param obser
   * @returns
   */
  async promisify(obser: Observable<any>){
      return new Promise(resolve => {
        obser.subscribe((v) => {
          resolve(v)
        })
      })
  }
}
function getListasExcel(wb: ExcelJS.Workbook, id: Number) {
  var listas = {}
  for(var i = 2;i<id;i++){
    var ws = wb.getWorksheet(i)
    var valores = []
    ws.eachRow((r, rn) => {

          valores.push(r.getCell(1).value)

    })
    listas[ws.name] = valores;
  }

  return listas;
}

